(function () {
  // Su touch/mobile non attivare il cursore custom
  if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;

  var CURSOR_NORMAL = 'https://cdn.shopify.com/s/files/1/1884/9319/files/Cursore_with_border_32.png';
  var CURSOR_HOVER  = 'https://cdn.shopify.com/s/files/1/1884/9319/files/with_border_32.png';
  var HOVER_SELECTOR = 'a, a *, button, button *, input[type="submit"], [role="button"], [onclick], .product-card, .product-card *';

  var cursorEl = document.createElement('div');
  cursorEl.className = 'custom-cursor';
  cursorEl.style.backgroundImage = 'url(' + CURSOR_NORMAL + ')';
  document.documentElement.appendChild(cursorEl);

  var isHover = false;
  var rafId = null;
  var x = 0, y = 0;

  function render() {
    cursorEl.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
    rafId = null;
  }

  function onMouseMove(e) {
    x = e.clientX;
    y = e.clientY;
    if (!rafId) rafId = requestAnimationFrame(render);
    if (!cursorEl.classList.contains('is-visible')) cursorEl.classList.add('is-visible');

    var hovering = !!(e.target && e.target.closest && e.target.closest(HOVER_SELECTOR));
    if (hovering !== isHover) {
      isHover = hovering;
      cursorEl.style.backgroundImage = 'url(' + (isHover ? CURSOR_HOVER : CURSOR_NORMAL) + ')';
    }
  }

  function onLeave() {
    cursorEl.classList.remove('is-visible');
  }

  document.addEventListener('mousemove', onMouseMove, { passive: true });
  document.addEventListener('mouseleave', onLeave);
  window.addEventListener('blur', onLeave);
})();